import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Observable, ReplaySubject} from "rxjs";
import {Document} from "../../../shared/interface/document";
import {Mailing} from "../../../shared/interface/mailing";
import {DocumentService} from "../../../shared/services/document.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {Router} from "@angular/router";
import {AuthService} from "../../../shared/services/auth.service";
import {MailingService} from "../../../shared/services/mailing.service";
import {first, takeUntil} from "rxjs/operators";
import {Dictionary} from "../../../shared/interface/dictionary";
import {DictService} from "../../../shared/services/dict.service";
import {InsuranceCompany} from "../../../shared/interface/insurance-company";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {InsuranceCompanyService} from "../../../shared/services/insurance-company.service";
import {Attachments} from "../../../shared/interface/attachments";
import {Regional} from "../../../shared/interface/regional";
import {RegionalService} from "../../../shared/services/regional.service";
import {Department} from "../../../shared/interface/department";
import {DepartmentService} from "../../../shared/services/department.service";

@Component({
  selector: 'app-email-send-details-view',
  templateUrl: './email-send-details-view.component.html',
  styleUrls: ['./email-send-details-view.component.scss']
})
export class EmailSendDetailsViewComponent implements OnInit, OnDestroy {
  @Input() mailing: Observable<Mailing>;

  mailingObject?: Mailing;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  iddTrainingStatus: Dictionary[] = [];
  contractStatus: Dictionary[] = [];
  contractType: Dictionary[] = [];
  contractTypeOfwca: Dictionary[] = [];
  contractStatusOfwca: Dictionary[] = [];
  registrationList: InsuranceCompany[] = [];
  registrationListOfwca: InsuranceCompany[] = [];
  regional: Regional[] = [];
  departmentList: Department[] = [];

  constructor(
    private mailingService: MailingService,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private router: Router,
    private auth: AuthService,
    private dictService: DictService,
    private insuranceCompanyService: InsuranceCompanyService,
    private regionalsService: RegionalService,
    private departmentsService: DepartmentService,
  ) {
    this.registrationList = [];
    this.registrationListOfwca = [];
    this.insuranceCompanyService.loadList(0, 1000, {});
  }

  ngOnInit(): void {
    this.mailing
      .pipe(takeUntil(this.destroyed$))
      .subscribe((mailing: Mailing) => {
        this.mailingObject = mailing;
        this.iddTrainingStatus = [];
        this.contractTypeOfwca = [];
        this.contractStatusOfwca = [];
        this.contractType = [];
        this.contractStatus = [];
        this.departmentList = [];
        this.mailingObject.iddTrainingStatus.forEach((dictId: number) => {
          this.dictService.getDict(dictId)
            .subscribe((dict: Dictionary) => {
              this.iddTrainingStatus.push(dict);
            });
        });
        this.mailingObject.contractTypeOfwca.forEach((dictId: number) => {
          this.dictService.getDict(dictId)
            .subscribe((dict: Dictionary) => {
              this.contractTypeOfwca.push(dict);
            });
        });
        this.mailingObject.contractStatusOfwca.forEach((dictId: number) => {
          this.dictService.getDict(dictId)
            .subscribe((dict: Dictionary) => {
              this.contractStatusOfwca.push(dict);
            });
        });
        this.mailingObject.contractType.forEach((dictId: number) => {
          this.dictService.getDict(dictId)
            .subscribe((dict: Dictionary) => {
              this.contractType.push(dict);
            });
        });
        this.mailingObject.contractStatus.forEach((dictId: number) => {
          this.dictService.getDict(dictId)
            .subscribe((dict: Dictionary) => {
              this.contractStatus.push(dict);
            });
        });
        this.mailingObject.regional.forEach((uuid: string) => {
          this.regionalsService.getRegional(uuid)
            .pipe(first())
            .subscribe((regional: Regional) => {
              this.regional.push(regional);
            });
        });
        this.insuranceCompanyService.getInsuranceCompaniesPageSubject()
          .pipe(first())
          .subscribe((result: CountedAndPaginated<InsuranceCompany>) => {
            result.items.forEach((insuranceCompany: InsuranceCompany) => {
              if (  this.mailingObject.registrationList.includes(insuranceCompany.id)) {
                this.registrationList.push(insuranceCompany);
              }
              if (  this.mailingObject.registrationListOfwca.includes(insuranceCompany.id)) {
                this.registrationListOfwca.push(insuranceCompany);
              }
            });

          });
        this.mailingObject.departmentList.forEach((uuid: string) => {
          this.departmentsService.get(uuid)
            .pipe(first())
            .subscribe((department: Department) => {
              this.departmentList.push(department);
            });
        });
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  downloadAttachmentFile(uuid: string): void {
    this.mailingService.downloadAttachmentFile(uuid);
  }
}
